import { auth } from '@/firebase';

const URL = 'https://us-central1-mesh-db-stg.cloudfunctions.net/action';
const URLV2 = 'https://faas-nyc1-2ef2e6cc.doserverless.co/api/v1/web/fn-12f47b02-5e16-417c-b4e1-1566a1d5fe44/v1/actions';

class Action {
    static async get(path='', token=null) {
        // Handle regular REST API requests
        const response = await fetch(`${URL}${path}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
                'Content-Type': 'application/json',
            },
        });

        return response.json();
    }

    static async post(path='', body, token=null) {
        const response = await fetch(`${URL}${path}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
                'Content-Type': 'application/json',
            },
            body: body,
        });

        return response.json();
    }

    static async put(path='', body, token=null) {
        const response = await fetch(`${URL}${path}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
                'Content-Type': 'application/json',
            },
            body: body,
        });
        return response.json();
    }

    static async delete(path='', body, token=null) {
        const response = await fetch(`${URL}${path}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
                'Content-Type': 'application/json',
            },
            body: body,
        });
        return response.json();
    }
}

class ActionV2 {
    static async get(path='', token=null) {
        // Handle regular REST API requests
        // console.log('token', await auth.currentUser.getIdToken());
        const response = await fetch(`${URLV2}${path}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
                'Content-Type': 'application/json',
            },
        });

        return response;
    }

    static async post(path='', body, token=null) {
        const response = await fetch(`${URLV2}${path}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
                'Content-Type': 'application/json',
            },
            body: body,
        });

        return response;
    }
}

export { Action, ActionV2 };